import {Store} from '@gongxigames/framework/core';
import {UiServiceV2} from '@gongxigames/framework/slotV2/baseClasses/uiServiceV2/UIServiceV2';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {Container} from 'pixi.js';
import {$DebugGameFrame} from './components/DebugGameFrame';
import {$DebugGameSize} from './components/DebugGameSize';

export class DebugOverlayService extends UiServiceV2 {
    public static NAME = Symbol('DebugOverlayService');

    private show = Store.signal(false);

    public onInit(): void {
        const gameFrame = $DebugGameFrame({show: this.show}) as Container;
        const gameSize = $DebugGameSize({show: this.show}) as Container;

        slotStore.stage_rootContainer.value.addChild(gameFrame);
        slotStore.stage_rootContainer_game.value.addChild(gameSize);
    }

    public onSetupEvents(): void {
        this.emitter.on('CORE.input.keydown', this.onToggleShow.bind(this));
    }

    private onToggleShow(event: KeyboardEvent) {
        if(event.code === 'KeyO') {
            this.show.value = !this.show.value;
        }
    }
}
